import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Box, Typography, IconButton, Avatar, Rating } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { $crud } from "../../utils/CrudFactory";
import { timeAgo } from "../../helper/functions";

const ReviewCard = ({ driverName, updatedAt, clientRating }) => (
  <Box
    sx={{
      backgroundColor: "#ffffff",
      padding: "16px",
      marginBottom: "20px",
      minHeight: "90px",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0px 5px 4px rgba(0, 0, 0, 0.15)", 
    }}
  >
    {/* Top section: avatar, name, date, rating */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Avatar
          src={""}
          alt={driverName}
          sx={{ width: "35px", height: "35px" }}
        />
        <Box
          sx={{
            display: "flex",
            gap: "5px",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", color: "black" }}
          >
            {driverName || "NA"}
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "gray" }}>
            {timeAgo(clientRating.createdAt)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Rating
          value={clientRating.rating}
          precision={0.5}
          readOnly
          size="small"
        />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
          {clientRating.rating}
        </Typography>
      </Box>
    </Box>

    {/* Review text */}
    <Typography
      sx={{ fontSize: "14px", mt: 2, color: "#444", padding: "10px" }}
    >
      {clientRating.review || "NA"}
    </Typography>
  </Box>
);

export default function ReviewCarousel() {
  const [reviews, setReviews] = useState([]);
  const swiperRef = React.useRef(null);

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  useEffect(() => {
    async function fetchReviews() {
      try {
        const res = await $crud.retrieve("admin/client-reviews");
        setReviews(
          res.data.data.sort(
            (a, b) =>
              new Date(b.clientRating.createdAt) -
              new Date(a.clientRating.createdAt)
          )
        );
      } catch (e) {
        console.error(e);
      }
    }
    fetchReviews();
  }, []);

  return reviews.length > 0 ? (
    <>
      <Swiper
        slidesPerView={3}
        spaceBetween={30}
        pagination={{ clickable: true }}
        className="mySwiper"
        style={{
          width: "calc(375px * 3 + 30px * 2)",
          marginTop: "20px",
        }}
        breakpoints={{
          600: { slidesPerView: 2 },
          960: { slidesPerView: 3 },
        }}
        ref={swiperRef}
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <ReviewCard {...review} />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation buttons */}
      <Box
        position="absolute"
        top="0"
        right="0"
        display="flex"
        alignItems="center"
        zIndex={10}
      >
        <IconButton
          onClick={goPrev}
          sx={{
            mr: 1,
            background: "rgba(104, 60, 140, 0.35)",
            borderRadius: "14px",
            color: "rgba(104, 60, 140, 1)",
            padding: "13px",
          }}
        >
          <NavigateBeforeIcon />
        </IconButton>
        <IconButton
          onClick={goNext}
          sx={{
            background: "rgba(104, 60, 140, 0.35)",
            borderRadius: "14px",
            color: "rgba(104, 60, 140, 1)",
            padding: "13px",
          }}
        >
          <NavigateNextIcon />
        </IconButton>
      </Box>
    </>
  ) : (
    <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
      <Typography>No Reviews</Typography>
    </Box>
  );
}
